import {Component, HostBinding} from '@angular/core';

@Component({
  selector: 'app-time-info',
  templateUrl: './time-info.component.html',
})
export class TimeInfoComponent {
  @HostBinding('class.header-menu-item') time = true;
  public now: Date = new Date();

  constructor() {
    setInterval(() => {
      this.now = new Date();
    }, 5000);
  }

  getTime() {
    return this.now;
  }
}
